<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><img alt="" src="OEBPS/images/5-1.jpg"/></p>
<h1 class="chapter">Introduction</h1>
<p class="center1">When we were first approached by David &amp; Charles to collaborate on a book of sewn toys, we were extremely excited and honoured. Imagine being given the opportunity to work with your sibling on a project that is guaranteed to generate so much pleasure and fulfilment. We had bundles of fun deciding which creatures we would best enjoy sharing with you.</p>
<p class="center1">As each creature came to life, we began to see the bigger picture and our excitement grew. When the day arrived to send our creations to the other side of the world, we were confident that they were going to be in the right hands, but we could never have envisaged just how wonderful the end result would be.</p>
<p class="center1">So now meet our magical collection of soft toy personalities, which you can easily re-create following the detailed step-by-step instructions. Close-up photos home in on the particular features – whether it’s their ears, facial expressions or clothing – that give them their special individual character, so that you too can bring each creature to life. As well as templates for all the soft toys, the section at the back of the book advises you on the basic tools you’ll need, choosing fabric to create the most exciting effects and the simple sewing techniques involved to achieve professional results.</p>
<p class="center1">We can be sure that as you make these creatures for yourself or your loved ones, they will bring you as much joy as they did us.</p>
<p class="center1">May the floss be with you!</p>
<p class="center1"><span class="big">Melly &amp; Rosie</span></p>
<p class="center1"><img alt="" src="OEBPS/images/6-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?58ab5a2a